import React from 'react';
import { CustomTooltip } from '../Tooltip/Tooltip';
import { useLinesContext } from '../../../contexts/Lines';
import { noOverflow } from '../../../themes/styles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import TelegramIcon from '@material-ui/icons/Telegram';
import LineNameEdit from './LineNameEdit';

const useStyles = makeStyles((theme: any) => ({
  root: {
    ...(noOverflow as object),
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(1),
    },
  },
  lineNameWrapper: {
    display: 'flex',
    alignItems: 'center',
    ...(noOverflow as object),
  },
  lineName: {
    maxWidth: '100%',
    cursor: 'default',
    color: 'inherit',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.h6.fontSize,
    },
  },
  editActiveLineName: { marginLeft: 'auto', marginRight: theme.spacing(0.5) },
}));

export default function LineName({
  line,
  handleEditActiveLineDetails,
  setLineInfoDuringEdit,
  addOrDeleteError,
}) {
  const classes = useStyles();
  const { editLineClick } = useLinesContext();
  const lineName = line.name;
  const isNameOnEdit = line.edit || line.editActiveNameLine;

  return (
    <div className={classes.root}>
      {isNameOnEdit && (
        <LineNameEdit
          line={line}
          setLineInfoDuringEdit={setLineInfoDuringEdit}
          addOrDeleteError={addOrDeleteError}
        />
      )}
      {line.editActiveNameLine && (
        <CustomTooltip arrow title={'Save'} placement="top">
          <div className={classes.editActiveLineName}>
            <IconButton
              size="small"
              onClick={() => {
                handleEditActiveLineDetails(line);
              }}
            >
              <TelegramIcon />
            </IconButton>
          </div>
        </CustomTooltip>
      )}
      {!isNameOnEdit && (
        <div
          className={classes.lineNameWrapper}
          onClick={() => editLineClick(line)}
        >
          <CustomTooltip
            arrow
            title={<Typography>{lineName}</Typography>}
            placement="top"
          >
            <Typography className={classes.lineName} noWrap={true}>
              {lineName}
            </Typography>
          </CustomTooltip>
        </div>
      )}
    </div>
  );
}
